module.exports = __webpack_public_path__ + "img/standort_pfarrei-st-martin_7.f5fc8146.jpeg";